import { useState } from "react";
import AutopilotExpandSearchModal from "../AutopilotExpandSearchModal";
import IconWithTooltipButton from "../shared/IconWithTooltipButton";
import classNames from "classnames";
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";
const AutopilotSessionExpandSearchButton = ({
  curatedSearchId,
}: {
  curatedSearchId: number | null;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <IconWithTooltipButton
        tooltipMessage="Expand search"
        icon={<ArrowsPointingOutIcon className={classNames("w-5", "h-5")} />}
        disabled={!curatedSearchId}
        isLoading={false}
        onButtonClick={() => setIsModalOpen(true)}
        analyticsField="Start expand search from autopilot session"
        analyticsProps={{ autopilotSessionId: curatedSearchId }}
      />
      <AutopilotExpandSearchModal
        onClose={() => setIsModalOpen(false)}
        curatedSearchId={isModalOpen ? curatedSearchId : null}
      />
    </>
  );
};

export default AutopilotSessionExpandSearchButton;
